import { Redirect, useLocation, useParams } from "react-router-dom";
import { T } from "../../../../../../util/t";
import { HeroSuccessPageSkeleton } from "../../../../../../layout/page/HeroSuccessPageSkeleton";
import { useOrganisation } from "../../../../../../providers/OrganisationProvider";
import { RegistrationSuccessPage } from "../../../../../../layout/registration/RegistrationSuccessPage";

const SeriesRegistrationSuccessPage = () => {
    const { seriesId } = useParams();
    const organisation = useOrganisation();
    const location = useLocation();

    if (!organisation) return <HeroSuccessPageSkeleton/>;
    if (!location.state?.registrationSuccessful) return <Redirect to={`/${organisation.shortName}/series/${seriesId}/sign-on`}/>;

    const series = organisation.series.find(s => s.id === seriesId);

    return (
        <RegistrationSuccessPage
            title={<T name={organisation.name} series={series?.name} shortName={organisation.shortName}>sign_up_success_callout</T>}
            subtitle={<T>You will receive an email shortly with your membership details.</T>}
            secondaryAction={{
                label: organisation.name,
                link: `/${organisation.shortName}`
            }}
            organisation={organisation}
        />
    );
};
export default SeriesRegistrationSuccessPage;

